// 반응형 헬퍼 (기획서 4.2 그리드 열 수, 5.4 양면 활성화 조건)

export function isMobileViewport() {
  return window.innerWidth <= 767;
}

// 기획서 4.2 라이브러리 그리드 열 수 표
export function libraryColumns(width = window.innerWidth) {
  if (width <= 480) return 2;
  if (width <= 767) return 3;
  if (width <= 1023) return 4;
  if (width <= 1439) return 5;
  return 6;
}

// 기획서 5.4: 양면 모드는 화면 너비 ≥ 1024px 일 때만 활성. (MVP-1은 단페이지 강제이지만
// 설정 보존을 위해 판정 함수는 유지)
export function canUseDoublePage(width = window.innerWidth) {
  return width >= 1024;
}
